import * as React from 'react'

import {
  Box,
} from '@mui/material'

import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Sidebar from '../../components/layout/Sidebar';
import Dashboard from './Dashboard';
import Source from './Source';
import User from './User';
import Group from './Group';
import Permission from './Permission';
import DimensionDefaults from './DimensionDefaults';
import MemberEmbeddings from './MemberEmbeddings';
import Help from './Help';
import Setting from './Setting';

import Toolbar from '../../components/layout/Toolbar';

import { getUser, logout } from '../../slices/auth';

function AdminPanel() {
  const [tab, setTab] = React.useState(0);
  const user = useSelector(state => state.auth.signed)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleTab = (value) => {
    setTab(value)
  }

  React.useEffect(() => {
    if(user) return;
    const role = localStorage.getItem('role');
    if(!role) navigate('/login')
    else if(role === 'USER') navigate('/dashboard'); 
    dispatch(getUser())
    .then(res => {
      if(res.error)
        console.log(res)
    })
    .catch(err => {
      dispatch(logout());
      navigate('/');
    });
  }, [dispatch, navigate, user])

  return (
    <Box
      sx={{ 
        flexGrow: 1, 
        bgcolor: 'background.paper', 
        display: 'flex'
      }}
      className='h-full'
    >
      <Sidebar
        value={tab}
        onChange={handleTab}
      />
      <Box className='w-full bg-content padding-content flex flex-column'>
        <Toolbar />
        {
          tab === 0 && <Dashboard />
        }
        {
          tab === 1 && <Source />
        }
        {
          tab === 2 && <User />
        }
        {
          tab === 3 && <Group />
        }
        {
          tab === 4 && <Permission />
        }
        {
          tab === 5 && <DimensionDefaults />
        }
        {
          tab === 10 && <MemberEmbeddings />
        }
        {
          tab === 7 && <Help />
        }
        {
          tab === 8 && <Setting />
        }
      </Box>
    </Box>
  );
}

export default AdminPanel;
